module.exports = __webpack_public_path__ + "static/media/firma_melissa.ecc83386.png";